module.exports = __webpack_public_path__ + "img/科学匹配师资@2x.e843255a.png";